// extracted by mini-css-extract-plugin
export default {"figure":"Image--figure--QbZoH","lazy":"Image--lazy--ZKA5h"};